import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmPasswordValidator } from '../registration/confirm-password.validator';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService } from 'src/app/api/api.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmRegistration } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-authentication-api-client';

@Component({
  selector: 'app-confirm-registration',
  templateUrl: './confirm-registration.component.html',
  styleUrls: ['./confirm-registration.component.scss']
})
export class ConfirmRegistrationComponent implements OnInit {
  confirmRegistrationForm: FormGroup;
  isLoading: boolean = false;
  passwordReseted: boolean = false;
  hasError: boolean = false;
  token: string;
  email: string;
  firstName: string;
  lastName: string;
  strongPasswordRegex: RegExp = /^(?=.*\d)(?=.*[!@#$%^&*.])[a-zA-Z0-9!@#$%^&*.].{8,}$/;

  // private fields
  constructor(private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private apiService: APIService,
    private router: Router,
    private toastr: ToastrService,
    private changeDetectorRef: ChangeDetectorRef,) {
  }

  ngOnInit(): void {
    this.initForm();
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
      this.email = params['email'];
    });
  }

  initForm() {
    this.confirmRegistrationForm = this.fb.group({
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.strongPasswordRegex)
        ]),
      ],
      firstName: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
        ]),
      ],
      lastName: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
        ]),
      ],
      cPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.strongPasswordRegex)
        ]),
      ],
    },
      {
        validator: ConfirmPasswordValidator.MatchPassword,
      });
  }

  submit() {
    this.passwordReseted = false;
    this.hasError = false;
    const confirmedRegistrationModel = new ConfirmRegistration();
    confirmedRegistrationModel.email = this.email;
    confirmedRegistrationModel.password = this.confirmRegistrationForm.controls["password"].value;
    confirmedRegistrationModel.token = this.token;
    confirmedRegistrationModel.lastName = this.confirmRegistrationForm.controls["lastName"].value;
    confirmedRegistrationModel.firstName = this.confirmRegistrationForm.controls["firstName"].value;

    this.isLoading = true;
    this.apiService.getKiaAuthenticationApiClient()
      .confirmRegistration(confirmedRegistrationModel)
      .then((r) => {
        this.passwordReseted = true;
        this.router.navigate(['/auth/login']);
        this.toastr.success('Account created', 'Success');
      }).catch((err) => this.hasError = true)
      .finally(() => {
        this.isLoading = false;

        this.changeDetectorRef.detectChanges();

      });
  }
}
